import { Box, Drawer, IconButton, Stack, Typography } from '@mui/material';
import xmarkIcon from 'assets/icons/xmark.svg';
import { SvgIconWrapper } from 'components/SvgIconWrapper';
import { castArray } from 'lodash-es';
import type { FC } from 'react';
import {
  ModalCloseButtonStyle,
  ModalContentStyle,
  ModalContentWrapperStyle,
  ModalFooterStyle,
  ModalHeaderStyle,
  ModalInnerWrapperStyle,
  ModalMainWrapperStyle,
  ModalStyle,
  ModalTitleStyle,
} from './Modal.styles';
import type { ModalProps } from './Modal.types';

const Modal: FC<ModalProps> = ({
  title,
  onClose,
  open,
  modalContent,
  modalFooter,
  onCloseIconClick,
  contentWrapperSx,
  modalHeaderDisplayItemsReversed,
  ...rest
}) => (
  <Drawer
    {...rest}
    anchor="bottom"
    open={open}
    onClose={onClose}
    sx={[ModalStyle, ...castArray(rest.sx)]}
  >
    <Box sx={ModalMainWrapperStyle} id="drawerContentWrapper">
      <Box sx={ModalInnerWrapperStyle}>
        <Box
          sx={[
            ModalHeaderStyle,
            ...castArray(modalHeaderDisplayItemsReversed ? { flexDirection: 'row-reverse' } : {}),
          ]}
        >
          <IconButton onClick={onCloseIconClick} sx={ModalCloseButtonStyle}>
            <SvgIconWrapper src={xmarkIcon} />
          </IconButton>

          <Typography sx={ModalTitleStyle} variant="h2">
            {title}
          </Typography>
        </Box>

        <Stack sx={ModalContentWrapperStyle}>
          <Box sx={[ModalContentStyle, ...castArray(contentWrapperSx)]}>{modalContent}</Box>

          {modalFooter && <Box sx={ModalFooterStyle}>{modalFooter}</Box>}
        </Stack>
      </Box>
    </Box>
  </Drawer>
);

export default Modal;
